var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"grey darken-1",attrs:{"app":"","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.toggleNavigationBar}}),_c('v-toolbar-title',[_c('span',{staticClass:"font-weight-bold font-weight-black title text-uppercase"},[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"flex-grow-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }